import { Stack } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { useMemo } from 'react';
import { useOrderDetails } from '../../containers/OrderDetailsContext';
import { getGroupedAirlineReferenceInfo } from '../../utils';
import AirlineInfoClickableContent from '../common/AirlineInfoClickableContent';
import AirlineReferenceAccordion from '../common/AirlineReferenceAccordion';
import CaretButtonWithDrawer from '../common/CaretButtonWithDrawer';
import { SHOW_AIRLINE_INFORMATION_QUERY_PARAMETER } from '../../constants/general';

const AirlineInformation = () => {
  const { t } = useTranslation();
  const { bounds, customerDetails, flightInformation } = useOrderDetails();

  const groupedAirlineReferenceInfo = useMemo(
    () => getGroupedAirlineReferenceInfo(bounds, customerDetails, flightInformation),
    [bounds, customerDetails, flightInformation],
  );

  return (
    <CaretButtonWithDrawer
      dataTestId="airline-info-button"
      drawerContent={
        <Stack>
          {groupedAirlineReferenceInfo.map((group, groupIndex) => (
            <AirlineReferenceAccordion
              airlineReferenceInfo={group}
              dataTestId={`airline-info-${groupIndex + 1}`}
              isInitiallyExpanded={groupedAirlineReferenceInfo.length < 2}
              key={`airline-info-accordion-${groupIndex}`}
            />
          ))}
        </Stack>
      }
      drawerTitle={t('OrderDetails.AirlineInfoClickableContent.Title')}
      queryParam={SHOW_AIRLINE_INFORMATION_QUERY_PARAMETER}
      shouldAddBorder={false}
    >
      <AirlineInfoClickableContent />
    </CaretButtonWithDrawer>
  );
};

export default AirlineInformation;
